class B2cWebSocket{
    ws = null;
    #alive = false;
    #params = null;
    #reconnect_timer = null;
    #heart_timer = null;
    #message_func = null;

    heartBeat = 50000;
    heartMsg = 'b2c_heart';

    reconnect = true;
    reconnectTime = 5000;
    reconnectTimes = 15;

    constructor(params) {
        this.#params = params;
        this.init()
    }

    init(){
        clearInterval(this.#reconnect_timer);
        clearInterval(this.#heart_timer);

        let params = this.#params;

        let {url, port} = params;
        let global_params = ['heartBeat', 'heartMsg', 'reconnect','reconnectTime','reconnectTimes'];
        Object.keys(params).forEach(key => {
            if (global_params.indexOf(key) != -1){
                this[key] = params[key];
            }
        });

        let ws_url = port ? url + ':' + port : url;

        delete this.ws;
        this.ws = new WebSocket(ws_url);

        if (this.#message_func){
            this.onmessage(this.#message_func);
        }

        this.ws.onopen = () => {
            //设置状态为开启
            this.#alive = true
            clearInterval(this.#reconnect_timer)
            //连接后进入心跳状态
            this.onheartbeat()
        }

        this.ws.onclose = () => {
            //设置状态为断开
            this.#alive = false

            clearInterval(this.#heart_timer)

            //自动重连开启  +  不在重连状态下
            if (true == this.reconnect) {
                /* 断开后立刻重连 */
                this.onreconnect()
            }
        }
    }

    onheartbeat(callback){
        if (true == this.#alive){
            this.#heart_timer = setInterval(()=>{
                this.sendMsg(this.heartMsg);
                callback ? callback(this) : false;
            }, this.heartBeat);
        }
    }

    onreconnect(callback){
        this.#reconnect_timer = setInterval(() => {
            if (this.reconnectTimes <= 0){
                //关闭定时器
                clearInterval(this.#reconnect_timer);
                //跳出函数之间的循环
                return;
            }else{
                //重连一次-1
                this.reconnectTimes--;
                //进入初始状态
                this.init()
                callback ? callback(this) : false;
            }
        }, this.reconnectTime);
    }

    sendMsg(msgText){
        if (true == this.#alive){
            msgText = typeof msgText == 'string' ?  msgText : JSON.stringify(msgText);
            this.ws.send(msgText);
        }
    }

    close(){
        if (true == this.#alive) {
            this.ws.close();
        }
    }

    onmessage(callback, all = false){
        this.ws.onmessage = data => {
            if (typeof data == 'string' && (data == this.heartMsg || data == "上线成功！")){
                console.log(data);
            }else{
                this.#message_func = callback
                callback(!all ? data.data : data)
            }
        }
    }

    onclose(callback){
        this.ws.onclose = event => {

            //设置状态为断开
            this.#alive = false

            clearInterval(this.#heart_timer)

            //自动重连开启  +  不在重连状态下
            if (true == this.reconnect) {
                /* 断开后立刻重连 */
                this.onreconnect()
            }
            callback ? callback(event) : false
        }
    }

    onerror(callback){
        this.ws.onerror = event => {
            callback ? callback(event) : false
        }
    }
}

export default B2cWebSocket;
